<div class="alc-container" [ngClass]="{ mobile: isMobile, hide: isLoading }">
  <div class="alc-header">
    <span class="logo"></span>
    <span class="title">{{ 'title' | translate }}</span>
    <span class="subtitle">{{ 'subtitle' | translate }}</span>
    <span *ngIf="pageInfo && pageInfo.privacy_link" class="privacy_link">
      {{ 'privacy_link_prefix' | translate
      }}<a target="_blank" href="{{ pageInfo.privacy_link }}">{{ 'privacy_link_label' | translate }}</a>
    </span>
    <button type="button" [attr.aria-label]="'aria_label/close' | translate" class="close-btn"></button>
  </div>
  <div #conversation (click)="unfocusInputs()" class="alc-conversation">
    <div [class.alc-spinner]="showSpinner"></div>
    <div
      *ngFor="let message of messages; last as isLast"
      (click)="unfocusInputs()"
      [hidden]="message.type === 'start-conversation' || message.type === 'seen-conversation'"
      [ngClass]="{ 'alc-from-brand': message.is_from_brand }"
      class="alc-message">
      <div *ngIf="message.postFailed" class="alc-message-post-failed"></div>
      <div *ngIf="message.is_from_brand" class="alc-message-avatar"></div>
      <div *ngIf="message.type === 'text'" class="alc-message-text">
        <ng-container *ngIf="message.text.parts?.length; else content">
          <span
            [attr.aria-hidden]="part.ariaHidden"
            *ngFor="let part of message.text.parts"
            [innerHTML]="part.text | linkify"></span>
        </ng-container>
        <ng-template #content>
          <span [innerHTML]="message.text.content | linkify"></span>
        </ng-template>

        <div *ngFor="let button of message.text.buttons" class="alc-message-url-button">
          <a
            *ngIf="button.type === 'url_button'"
            [href]="button.url_button.sanitizedUrl"
            [target]="button.url_button.open_link_in_new_tab ? '_blank' : '_self'"
            class="alc-message-url-button-link">
            {{ button.url_button.title }}
          </a>
        </div>
      </div>
      <div
        *ngIf="message.type === 'text_input'"
        class="alc-message-text"
        [innerHTML]="message.text_input.title | linkify"></div>
      <div *ngIf="message.type === 'button'" class="alc-message-text">{{ message.button.name }}</div>

      <!-- Keep this for backward compatibility -->
      <img
        [attr.alt]="'alt/an_image' | translate"
        *ngIf="message.type === 'image'"
        class="alc-message-image"
        [src]="message.image.url" />

      <!-- Now we will only have "files" messages, no more "images" -->
      <div *ngIf="message.type === 'file'">
        <div *ngIf="isImageFileMessage(message)">
          <img [attr.alt]="'alt/an_image' | translate" class="alc-message-image" [src]="message.file.url" />
        </div>
        <div *ngIf="!isImageFileMessage(message)" class="alc-message-text alc-message-file">
          <a [href]="message.file.url" target="_blank" class="filename">
            <span class="alc-message-file-icon"></span>
            <span class="alc-message-file-name">{{ message.file.file_name }}</span>
          </a>
        </div>
      </div>
      <div *ngIf="message.type === 'text_input_response'" class="alc-message-text">
        {{ message.text_input_response.content }}
      </div>
      <div
        *ngIf="message.type === 'progress_bar' && (isLast || message.monitor.uploadError)"
        [ngStyle]="{ 'background-size': (message.monitor.progress | async) + '% 100%' }"
        [ngClass]="{ 'alc-upload-error': message.monitor.uploadError }"
        class="alc-message-progress-bar">
        {{ message.monitor.fileName }} - {{ message.monitor.progress | async }}%
      </div>
      <div *ngIf="isLast && message.buttons" class="alc-buttons">
        <button
          type="button"
          *ngFor="let button of message.buttons"
          [attr.aria-label]="button.name"
          (click)="buttonClicked(button, message)"
          [ngClass]="{ 'alc-buttons-already-clicked': message.buttonAlreadyClicked }"
          class="alc-button">
          {{ button.name }}
        </button>
      </div>
    </div>
    <div class="alc-message alc-from-brand" (click)="unfocusInputs()" *ngIf="showTypingIndicator">
      <div class="alc-message-avatar"></div>
      <div class="alc-message-text alc-typing-indicator">
        <app-typing-indicator-animation></app-typing-indicator-animation>
      </div>
    </div>
  </div>
  <div class="alc-footer-with-menu">
    <div class="input-and-buttons-line">
      <button
        type="button"
        [attr.aria-label]="'aria_label/options' | translate"
        *ngIf="pageHasPersistentMenu()"
        (click)="togglePersistentMenu()"
        class="burger-button"></button>
      <textarea
        *ngIf="isRegularInput() && !shouldBlockInput()"
        #messageInput
        appTextareaAutoExpand
        [(ngModel)]="messageContent"
        [model]="messageContent"
        (keydown.enter)="enterPressedInTextarea($event)"
        [placeholder]="inputPlaceholder | translate"></textarea>
      <input
        *ngIf="isEmailInput() || shouldBlockInput()"
        #messageInput
        [(ngModel)]="messageContent"
        (keyup.enter)="sendInputMessage()"
        type="{{ inputType }}"
        [disabled]="shouldBlockInput()"
        [ngClass]="{ invalid: !inputIsValid }"
        [placeholder]="inputPlaceholder | translate" />
      <div *ngIf="isPhoneInput()" class="tel-input-container">
        <input
          #phoneInput
          type="tel"
          (keyup.enter)="phoneInputEnterPressed()"
          (blur)="phoneInputIsPristine = false"
          appTelInput
          [telInputOptions]="{ initialCountry: 'it' }"
          (telInputChange)="phoneInputChanged($event)"
          [ngClass]="{ invalid: !phoneInputIsPristine && !isPhoneInputValid() }"
          (intlTelInputObject)="telInputObject($event)" />
      </div>
      <app-file-upload-legacy
        *ngIf="isRegularInput() && !shouldBlockInput()"
        (fileChosen)="fileChosen($event)"></app-file-upload-legacy>
      <button
        type="button"
        [attr.aria-label]="'aria_label/send_message' | translate"
        *ngIf="!shouldBlockInput()"
        (click)="sendInputMessage()"
        class="send-button"></button>
    </div>
    <div *ngIf="showPersistentMenu && pageHasPersistentMenu()" class="persistent-menu visible">
      <button
        type="button"
        [attr.aria-label]="item.title"
        *ngFor="let item of pageInfo?.persistent_menu"
        (click)="menuItemClicked(item)"
        class="persistent-menu-item">
        <div [ngClass]="'menu-item-icon-' + item.type" class="menu-item-icon"></div>
        <div>{{ item.title }}</div>
      </button>
      <button
        type="button"
        [attr.aria-label]="'aria_label/close-menu' | translate"
        (click)="closePersistentMenu()"
        class="persistent-menu-close-item">
        <span class="close-menu">{{ 'close_menu' | translate }}</span>
        <span class="close-button"></span>
      </button>
    </div>
  </div>
</div>
